import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Programas() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const despertar = {
    title: 'Despertar',
    subtitle: 'Autoconhecimento e Liderança Pessoal',
    description: 'Descubra seu propósito, valores e potencial através de uma jornada profunda de autoconhecimento.',
    modules: [
      'Autoconhecimento e propósito de vida',
      'Inteligência emocional aplicada',
      'Valores pessoais e profissionais',
      'Liderança pessoal e autogestão',
      'Comunicação assertiva',
      'Planejamento de vida e carreira'
    ],
    duration: '40 horas',
    format: 'Presencial e Online',
    target: 'Jovens e adultos que buscam clareza sobre seu propósito e direção de vida'
  };

  const capacita = {
    title: 'Capacita',
    subtitle: 'Cursos Profissionalizantes e Técnicos',
    description: 'Capacitação técnica e profissional para o mercado de trabalho atual.',
    courses: [
      { name: 'Gestão de Pessoas', duration: '120h', level: 'Técnico' },
      { name: 'Administração', duration: '100h', level: 'Técnico' },
      { name: 'Marketing Digital', duration: '80h', level: 'Profissionalizante' },
      { name: 'Tecnologia da Informação', duration: '150h', level: 'Técnico' },
      { name: 'Atendimento ao Cliente', duration: '60h', level: 'Profissionalizante' },
      { name: 'Vendas e Negociação', duration: '70h', level: 'Profissionalizante' }
    ],
    benefits: [
      'Certificado reconhecido',
      'Material didático incluso',
      'Aulas práticas',
      'Professores especializados',
      'Encaminhamento ao mercado'
    ]
  };

  const geracaoValor = {
    title: 'Geração Valor',
    subtitle: 'Juventude e Liderança Transformadora',
    description: 'Programa especial para jovens que querem fazer a diferença em suas comunidades.',
    pillars: [
      {
        icon: 'ri-user-heart-line',
        title: 'Desenvolvimento Pessoal',
        description: 'Autoconhecimento, valores e propósito de vida'
      },
      {
        icon: 'ri-team-line',
        title: 'Liderança Comunitária',
        description: 'Como liderar e impactar positivamente sua comunidade'
      },
      {
        icon: 'ri-lightbulb-line',
        title: 'Empreendedorismo Social',
        description: 'Criar soluções para problemas sociais reais'
      },
      {
        icon: 'ri-speak-line',
        title: 'Comunicação e Influência',
        description: 'Desenvolver habilidades de comunicação e influência positiva'
      }
    ],
    duration: '6 meses',
    format: 'Híbrido (presencial + online)',
    target: 'Jovens de 16 a 29 anos'
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Cursos e Programas
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Escolha o caminho ideal para sua transformação pessoal e profissional
            </p>
          </div>
        </div>
      </section>

      {/* Despertar Section */}
      <section id="despertar" className="py-20 bg-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-semibold mb-4">
                Trilha de Desenvolvimento
              </div>
              <h2 className="text-4xl font-bold text-slate-900 mb-4">{despertar.title}</h2>
              <h3 className="text-2xl text-slate-700 mb-6">{despertar.subtitle}</h3>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                {despertar.description}
              </p>
              
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-slate-50 p-4 rounded-xl">
                  <i className="ri-time-line text-2xl text-blue-600 mb-2"></i>
                  <p className="text-sm text-slate-600">Duração</p>
                  <p className="font-bold text-slate-900">{despertar.duration}</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl">
                  <i className="ri-computer-line text-2xl text-blue-600 mb-2"></i>
                  <p className="text-sm text-slate-600">Formato</p>
                  <p className="font-bold text-slate-900">{despertar.format}</p>
                </div>
              </div>

              <div className="mb-8">
                <h4 className="font-bold text-slate-900 mb-4 text-lg">Módulos do Programa:</h4>
                <ul className="space-y-3">
                  {despertar.modules.map((module, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-green-600 text-xl mt-1"></i>
                      <span className="text-slate-700">{module}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <Link
                to="/inscricoes"
                className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Inscrever-se no Despertar
              </Link>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/3f7dc43841c7d8c6ddd18cbc68133ec0.jpg"
                alt="Programa Despertar"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Capacita Section */}
      <section id="capacita" className="py-20 bg-gradient-to-b from-slate-50 to-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-purple-100 text-purple-600 px-4 py-2 rounded-full font-semibold mb-4">
              Trilha Profissional
            </div>
            <h2 className="text-4xl font-bold text-slate-900 mb-4">{capacita.title}</h2>
            <h3 className="text-2xl text-slate-700 mb-6">{capacita.subtitle}</h3>
            <p className="text-lg text-slate-700 max-w-3xl mx-auto leading-relaxed">
              {capacita.description}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {capacita.courses.map((course, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-slate-100 hover:shadow-xl transition-all">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-blue-600 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-book-open-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-slate-900 mb-2">{course.name}</h4>
                <div className="flex items-center gap-4 text-sm text-slate-600 mb-4">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {course.duration}
                  </span>
                  <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-xs font-semibold">
                    {course.level}
                  </span>
                </div>
                <Link
                  to="/inscricoes"
                  className="text-blue-600 font-semibold hover:text-blue-700 flex items-center gap-2 cursor-pointer"
                >
                  Saiba mais
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-100">
            <h4 className="text-2xl font-bold text-slate-900 mb-6">Benefícios dos Cursos Capacita:</h4>
            <div className="grid md:grid-cols-2 gap-4">
              {capacita.benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <i className="ri-star-fill text-yellow-400 text-xl"></i>
                  <span className="text-slate-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Geração Valor Section */}
      <section id="geracao-valor" className="py-20 bg-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block bg-yellow-100 text-yellow-600 px-4 py-2 rounded-full font-semibold mb-4">
              Programa Especial
            </div>
            <h2 className="text-4xl font-bold text-slate-900 mb-4">{geracaoValor.title}</h2>
            <h3 className="text-2xl text-slate-700 mb-6">{geracaoValor.subtitle}</h3>
            <p className="text-lg text-slate-700 max-w-3xl mx-auto leading-relaxed mb-8">
              {geracaoValor.description}
            </p>
            <div className="flex flex-wrap justify-center gap-6 text-left">
              <div className="bg-slate-50 px-6 py-3 rounded-xl">
                <p className="text-sm text-slate-600">Duração</p>
                <p className="font-bold text-slate-900">{geracaoValor.duration}</p>
              </div>
              <div className="bg-slate-50 px-6 py-3 rounded-xl">
                <p className="text-sm text-slate-600">Formato</p>
                <p className="font-bold text-slate-900">{geracaoValor.format}</p>
              </div>
              <div className="bg-slate-50 px-6 py-3 rounded-xl">
                <p className="text-sm text-slate-600">Público</p>
                <p className="font-bold text-slate-900">{geracaoValor.target}</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {geracaoValor.pillars.map((pillar, index) => (
              <div key={index} className="bg-gradient-to-br from-slate-50 to-white p-8 rounded-2xl shadow-lg border border-slate-100">
                <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-2xl flex items-center justify-center mb-6">
                  <i className={`${pillar.icon} text-3xl text-slate-900`}></i>
                </div>
                <h4 className="text-2xl font-bold text-slate-900 mb-4">{pillar.title}</h4>
                <p className="text-slate-700 leading-relaxed">{pillar.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/inscricoes"
              className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-500 text-slate-900 px-8 py-4 rounded-full font-bold hover:from-yellow-500 hover:to-yellow-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Participar do Geração Valor
            </Link>
          </div>
        </div>
      </section>

      {/* Mentorias Section */}
      <section id="mentorias" className="py-20 bg-gradient-to-b from-slate-50 to-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20mentoring%20session%20mentor%20and%20mentee%20one%20on%20one%20meeting%20modern%20bright%20office%20collaborative%20discussion%20natural%20lighting%20warm%20atmosphere%20guidance%20coaching%20personal%20development%20professional%20photography%20authentic%20interaction%20inspiring%20supportive%20environment&width=800&height=600&seq=mentoria1&orientation=landscape"
                alt="Mentorias"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
            <div>
              <div className="inline-block bg-green-100 text-green-600 px-4 py-2 rounded-full font-semibold mb-4">
                Acompanhamento Individual
              </div>
              <h2 className="text-4xl font-bold text-slate-900 mb-4">Mentorias e Trilhas Personalizadas</h2>
              <p className="text-lg text-slate-700 mb-6 leading-relaxed">
                Acompanhamento individual com mentores especializados para acelerar seu desenvolvimento pessoal e profissional.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-star-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">Mentoria de Carreira</h4>
                    <p className="text-slate-700">Orientação para transição de carreira e crescimento profissional</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">Mentoria de Propósito</h4>
                    <p className="text-slate-700">Descoberta e alinhamento do seu propósito de vida</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-rocket-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 mb-1">Mentoria de Liderança</h4>
                    <p className="text-slate-700">Desenvolvimento de habilidades de liderança e gestão</p>
                  </div>
                </div>
              </div>

              <Link
                to="/inscricoes"
                className="inline-block bg-green-600 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Agendar Mentoria
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* EAD Section */}
      <section id="ead" className="py-20 bg-white scroll-mt-20">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full font-semibold mb-4">
                Trilha Online
              </div>
              <h2 className="text-4xl font-bold text-slate-900 mb-4">Plataforma EAD</h2>
              <h3 className="text-2xl text-slate-700 mb-6">Aprenda no seu ritmo, de onde estiver</h3>
              <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                Nossa plataforma de ensino a distância oferece cursos completos com vídeos, exercícios práticos e certificação automática.
              </p>

              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="bg-slate-50 p-6 rounded-xl text-center">
                  <i className="ri-video-line text-3xl text-blue-600 mb-2"></i>
                  <p className="font-bold text-slate-900">Videoaulas</p>
                  <p className="text-sm text-slate-600">HD de alta qualidade</p>
                </div>
                <div className="bg-slate-50 p-6 rounded-xl text-center">
                  <i className="ri-file-text-line text-3xl text-blue-600 mb-2"></i>
                  <p className="font-bold text-slate-900">Exercícios</p>
                  <p className="text-sm text-slate-600">Práticos e aplicáveis</p>
                </div>
                <div className="bg-slate-50 p-6 rounded-xl text-center">
                  <i className="ri-medal-line text-3xl text-blue-600 mb-2"></i>
                  <p className="font-bold text-slate-900">Certificado</p>
                  <p className="text-sm text-slate-600">Reconhecido</p>
                </div>
                <div className="bg-slate-50 p-6 rounded-xl text-center">
                  <i className="ri-customer-service-line text-3xl text-blue-600 mb-2"></i>
                  <p className="font-bold text-slate-900">Suporte</p>
                  <p className="text-sm text-slate-600">Tutores disponíveis</p>
                </div>
              </div>

              <Link
                to="/inscricoes"
                className="inline-block bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Acessar Plataforma EAD
              </Link>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=person%20studying%20online%20laptop%20computer%20modern%20home%20office%20e%20learning%20platform%20focused%20engaged%20natural%20lighting%20warm%20comfortable%20environment%20professional%20photography%20authentic%20remote%20learning%20digital%20education%20clean%20organized%20workspace&width=800&height=600&seq=ead1&orientation=landscape"
                alt="Plataforma EAD"
                className="rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 via-purple-600 to-blue-700 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400 rounded-full blur-3xl"></div>
        </div>
        <div className="container mx-auto px-6 text-center relative z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Escolha seu programa e comece agora
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Não espere mais para transformar sua vida. Inscreva-se hoje e dê o primeiro passo rumo ao futuro que você deseja.
          </p>
          <Link
            to="/inscricoes"
            className="inline-block bg-yellow-400 text-slate-900 px-10 py-5 rounded-full font-bold text-lg hover:bg-yellow-500 transition-all shadow-2xl hover:shadow-yellow-400/50 whitespace-nowrap cursor-pointer"
          >
            Fazer minha inscrição
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
